import { ILogger } from '@cian/logger';
import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import * as styles from './LoadableErrorBoundary.css';

interface ILoadableErrorBoundaryProps {
  logger?: ILogger;
  onRetry(): void;
  children?: React.ReactNode;
}

interface ILoadableErrorBoundaryState {
  hasError: boolean;
}

export class LoadableErrorBoundary extends React.Component<ILoadableErrorBoundaryProps, ILoadableErrorBoundaryState> {
  public state: ILoadableErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(): ILoadableErrorBoundaryState {
    return {
      hasError: true,
    };
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    if (this.props.logger) {
      this.props.logger.error(error, { ...info });
    }
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className={styles['container']}>
          <p className={styles['text']}>
            Во время загрузки произошла ошибка. Пожалуйста, проверьте своё интернет соединение и попробуйте ещё раз.
          </p>
          <Button onClick={this.handleRetryClick}>Повторить</Button>
        </div>
      );
    }

    return this.props.children;
  }

  private handleRetryClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    this.props.onRetry();

    this.setState({
      hasError: false,
    });
  };
}
